<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item">
        <label class="filter__item__title">
          {{ $t('shared.component.filter.name') }}
        </label>
        <div class="filter__item__body">
          <i-input
            v-model="form.name"
            type="text"
            :clearable="true"
            :placeholder="$t('shared.component.filter.search')"
          />
        </div>
      </div>
      <div v-if="show_mcc" class="filter__item">
        <label class="filter__item__title">
          {{ $t('shared.component.filter.mcc') }}
        </label>
        <div class="filter__item__body">
          <i-input
            v-model="form.mcc"
            type="number"
            :clearable="true"
            :placeholder="$t('shared.component.filter.search')"
          />
        </div>
      </div>
      <div v-if="show_mnc" class="filter__item">
        <label class="filter__item__title">
          {{ $t('shared.component.filter.mnc') }}
        </label>
        <div class="filter__item__body">
          <i-input
            v-model="form.mnc"
            type="number"
            :clearable="true"
            :placeholder="$t('shared.component.filter.search')"
          />
        </div>
      </div>

      <template v-if="show_code">
        <div class="filter__item">
          <label class="filter__item__title">
            {{ $t('prices.common.field.code') }}
          </label>
          <div class="filter__item__body">
            <i-input
              v-model="form.code"
              type="number"
              :clearable="true"
              :placeholder="$t('prices.common.field.code')"
            />
          </div>
        </div>
      </template>
      <template v-if="show_trunk_filter">
        <div class="filter__item">
          <label class="filter__item__title">
            {{ $t('prices.common.field.trunk') }}
          </label>
          <div class="filter__item__body">
            <trunk-select :value="selectedTrunk" :options="trunks" @input="selectTrunk" />
          </div>
        </div>
      </template>

      <div class="filter__item filter__item--button">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import { mapGetters, mapActions } from 'vuex';
  import TrunkSelect from './trunk-select';
  import {
    isVoiceService,
    isVoiceVerificationService,
    isSmsVerificationService
  } from '@utils/services';

  const initialState = {
    name: undefined,
    mcc: undefined,
    mnc: undefined,
    code: undefined
  };

  export default {
    components: {
      FilterWrapper,
      TrunkSelect
    },

    props: {
      type: {
        type: [String, undefined],
        required: true
      },

      trunks_exist: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      form: initialState
    }),

    computed: {
      ...mapGetters('core/auth', ['user']),
      ...mapGetters('prices/rates/table', ['trunks', 'selectedTrunk']),
      show_trunk_filter() {
        return this.trunks_exist && this.trunks?.length > 1;
      },

      show_mcc() {
        return isSmsVerificationService(this.type) || this.type === 'sms' || this.type === 'hlr';
      },

      show_mnc() {
        return isSmsVerificationService(this.type) || this.type === 'sms';
      },
      show_code() {
        return isVoiceService(this.type) || isVoiceVerificationService(this.type);
      }
    },

    watch: {
      type: {
        handler: function () {
          if (this.trunks_exist) {
            this.setSelectedTrunk(this.trunks[0].id);
          } else {
            this.setSelectedTrunk(null);
          }
          this.form = { ...initialState };
          this.getAsyncData({ current_page: 1, sort_column: 'display_name' });
        },
        immediate: true
      }
    },

    created() {
      if (this.trunks_exist) {
        this.setSelectedTrunk(this.trunks[0].id);
      } else {
        this.setSelectedTrunk(null);
      }
    },

    methods: {
      ...mapActions('prices/rates/table', ['search', 'setSelectedTrunk', 'getAsyncData']),

      selectTrunk(trunk_id) {
        this.setSelectedTrunk(trunk_id);
      },

      submit() {
        const { name, mcc, mnc, code } = this.form;
        const params = {
          search: name,
          code: this.show_code ? code : undefined,
          mcc: this.show_mcc ? mcc : undefined,
          mnc: this.show_mnc ? mnc : undefined
        };

        this.search({ ...params });
      }
    }
  };
</script>
